module.exports = __webpack_public_path__ + "img/active-user.c495b33c.svg";